var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareDowload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_File_Upload_Line",
    "data-name": "icons/File Upload/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.08,
    height: 25.764,
    viewBox: "0 0 21.08 25.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,4.684A4.684,4.684,0,0,1,4.684,0h9.771a4.684,4.684,0,0,1,3.312,1.372l1.94,1.94A4.685,4.685,0,0,1,21.08,6.625V21.08A4.684,4.684,0,0,1,16.4,25.764H4.684A4.684,4.684,0,0,1,0,21.08ZM18.737,8.2V21.08A2.342,2.342,0,0,1,16.4,23.422H4.684A2.342,2.342,0,0,1,2.342,21.08V4.684A2.342,2.342,0,0,1,4.684,2.342h8.2V4.684A3.513,3.513,0,0,0,16.4,8.2Zm-.13-2.342a2.342,2.342,0,0,0-.556-.887l-1.94-1.94a2.342,2.342,0,0,0-.887-.556V4.684A1.171,1.171,0,0,0,16.4,5.855Z",
    transform: "translate(0)",
    fill: "#2148ff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.236,10.451a1.168,1.168,0,0,1-.38-.254L.343,6.684A1.171,1.171,0,0,1,2,5.027L3.513,6.542V1.171a1.171,1.171,0,1,1,2.342,0v5.37L7.37,5.027A1.171,1.171,0,0,1,9.026,6.684L5.513,10.2A1.171,1.171,0,0,1,4.236,10.451Z",
    transform: "translate(5.856 9.369)",
    fill: "#2148ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDowload);
export default __webpack_public_path__ + "static/media/share-dowload.2cf34086c3ce2e8512f422d0bab08c62.svg";
export { ForwardRef as ReactComponent };